import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from '@/stores/index.js';
import VueResource from 'vue-resource';
import VueMeta from 'vue-meta';
import './registerServiceWorker';
//import 'bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faDog, faExclamation, faTicketAlt, faMobileAlt, faTv, faCar, faMotorcycle, faBus, faTruck, faStar, faSave, faStarHalf, faInfoCircle, faShieldAlt, faEuroSign, faFileSignature, faBinoculars, faTimes, faChevronLeft, faChevronRight, faCheck, faExclamationTriangle, faPlus, faTrashAlt, faFileDownload, faFileInvoice, faCamera, faFirstAid, faTrafficLight, faEnvelope, faUsers } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faLinkedin, faFacebook, faGoogle, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faStar as farStar, faStarHalf as farStarHalf, faComment as farComment, faComments as farComments, faCopy as farCopy, faCalendarAlt as farCalendarAlt, faFileAlt as farFileAlt } from '@fortawesome/free-regular-svg-icons'


library.add(faDog, faExclamation, faTicketAlt, faMobileAlt, faTv, faCar, faMotorcycle, faBus, faTruck, faStar, faSave, faStarHalf, faInfoCircle, faShieldAlt, faEuroSign, faFileSignature, faBinoculars, faTimes, faChevronLeft, faChevronRight, faCheck, faExclamationTriangle, faPlus, faTrashAlt, faFileDownload, faFileInvoice, faCamera, faFirstAid, faTrafficLight, faGoogle, faInstagram, faLinkedin, faFacebook, faWhatsapp, faEnvelope, faUsers);
library.add(farStar, farStarHalf, farComment, farComments, farCopy, farCalendarAlt, farFileAlt)

Vue.component('font-awesome-icon', (resolve) => { resolve(FontAwesomeIcon) });

Vue.config.performance = true
Vue.config.productionTip = false

Vue.use(VueResource);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});


new Vue({
  router,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
  //mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
  store,
  created() {

    if(localStorage.getItem('version') != 2)
    {
      console.log('New version available, reload page...');
      localStorage.setItem('version', 2);
      return window.location.reload(true);
    }
    console.log('Latest version');
    Vue.http.options.root = process.env.VUE_APP_API_URL;
    const token = localStorage.getItem("token");
    if (token) {
      Vue.http.headers.common['Authorization'] = 'Bearer ' + token
    }
    
    let _log = console.log,
        _warn = console.warn,
        _error = console.error;

    console.error = function() {
      let args = '';
        for(let i = 0; i < arguments.length; i++)
        {
          args += arguments[i] + ';';
        }
      Vue.http.post('api/ConsoleLog', { type: 'error', page: window.location.href, message: args });
      return _error.apply(console, arguments);
    };

    console.warn = function() {
      let args = '';
        for(let i = 0; i < arguments.length; i++)
        {
          args += arguments[i] + ';';
        }
      Vue.http.post('api/ConsoleLog', { type: 'warn', page: window.location.href, message: args });
      return _warn.apply(console, arguments);
    };
  },
}).$mount('#app')
